<template>
  <div class="data-table-page">
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        align="center"
        prop="time"
        label="时间">
      </el-table-column>
      <el-table-column
        align="center"
        prop="airQualityNO2"
        label="NO2">
      </el-table-column>
      <el-table-column
        align="center"
        prop="airQualityCO"
        label="CO">
      </el-table-column>
      <el-table-column
        align="center"
        prop="airQualityAirQuality"
        label="空气质量状况">
      </el-table-column>
      <el-table-column
        align="center"
        prop="airQualityPM10"
        label="PM10">
      </el-table-column>
      <el-table-column
        align="center"
        prop="airQualityPM25"
        label="PM25">
      </el-table-column>
      <el-table-column
        align="center"
        prop="airQualitySO2"
        label="SO2">
      </el-table-column>

      <el-table-column
        align="center"
        prop="airQualityAQI"
        label="AQI">
      </el-table-column>
      <el-table-column
        align="center"
        prop="airQualityO3"
        label="O3">
      </el-table-column>
      <el-table-column
        align="center"
        prop="peopleFeelHum"
        label="人体湿度">
      </el-table-column>
      <el-table-column
        align="center"
        prop="peopleFeelWindspeed"
        label="风速">
      </el-table-column>
      <el-table-column
        align="center"
        prop="peopleFeelFeelLevel"
        label="人体舒适度等级">
      </el-table-column>
      <el-table-column
        align="center"
        prop="peopleFeelTemp"
        label="人体温度">
      </el-table-column>
      <el-table-column
        align="center"
        prop="peopleFeelPeopleFeel"
        label="人体舒适度指数">
      </el-table-column>
      <el-table-column
        align="center"
        prop="waterQualityTemp"
        label="水温">
      </el-table-column>
      <el-table-column
        align="center"
        prop="waterQualityEC"
        label="电导率">
      </el-table-column>
      <el-table-column
        align="center"
        prop="waterQualityDO"
        label="溶解氧">
      </el-table-column>
      <el-table-column
        align="center"
        prop="waterQualityLevel"
        label="水质">
      </el-table-column>

      <el-table-column
        align="center"
        prop="waterQualityNTU"
        label="浊度">
      </el-table-column>
      <el-table-column
        align="center"
        prop="waterQualityWQI"
        label="水质污染指数">
      </el-table-column>
      <el-table-column
        align="center"
        prop="waterQualityCl"
        label="氯化物">
      </el-table-column>
      <el-table-column
        align="center"
        prop="waterQualityPH"
        label="酸碱值">
      </el-table-column>
      <el-table-column
        align="center"
        prop="fireRiskAssessmentSmog"
        label="烟雾">
      </el-table-column>
      <el-table-column
        align="center"
        prop="fireRiskAssessmentCO"
        label="氧化碳">
      </el-table-column>
      <el-table-column
        align="center"
        prop="fireRiskAssessmentFirelevel"
        label="火灾风险等级">
      </el-table-column>

      <el-table-column
        align="center"
        prop="fireRiskAssessmentFireprobability"
        label="火灾概率">
      </el-table-column>
      <el-table-column
        align="center"
        prop="fireRiskAssessmentTem"
        label="温度">
      </el-table-column>
      <el-table-column
        align="center"
        prop="fireRiskAssessmentHum"
        label="湿度">
      </el-table-column>

      <el-table-column
        align="center"
        prop="fileSource"
        label="文件来源">
      </el-table-column>
      <el-table-column
        align="center"
        prop="fileDigest"
        label="文件指纹">
      </el-table-column>
      <el-table-column
        align="center"
        prop="digest"
        label="数据摘要">
      </el-table-column>
      <el-table-column
        align="center"
        prop="blockTime"
        label="区块时间">
      </el-table-column>

    </el-table>

        <el-pagination
          @current-change="fetchList"
          :current-page.sync="currentPage"
          layout="prev, pager, next"
          :total="totalNum">
        </el-pagination>
      </div>

</template>

<script>

export default {
  data() {
    return {
      currentPage: 1,
      tableData: [],
      totalNum: 10
    }
  },
  components: {},
  computed: {},

  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.$http(null, '/data/power-environment/evidence/page', {
        cur: this.currentPage++,
        size: 10
      }, 'get').then(res => {
        this.tableData = res.records
        this.currentPage = res.current
        this.totalNum = res.total
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.data-table-page::v-deep {
  padding: 20px;

  .el-table, .el-table__expanded-cell, .el-table tr, .el-table .el-table__expanded-cell, .el-table th.el-table__cell{
    background: transparent;
  }

  .el-table, .el-table thead {
    color: #fff;
  }



  .el-table__body {
    tr:hover>td{
      color: rgba(29, 35, 47, 1);
    }
  }

  .el-pagination {
    margin-top: 20px;
  }

  .el-pagination button:disabled, .el-pager li, .el-pagination .btn-next, .el-pagination .btn-prev{
    background: transparent;
    color: #fff;
  }

  .el-pager li.active {
    background: #fff;
    color: rgba(29, 35, 47, 1);
  }

}

.layout-container {
  height: 100vh;

  .el-aside {
    background-color: #232323;

    .el-menu {
      border-right: none;

    }
  }


}

</style>
